export default "/images/0088fa66e913d9972e05648f96d6747b.avif";